// This file is AUTOGENERATED, do not edit it manually!!!

export const taskDetails = {
    actualCompletionDate: 'Data de Conclusão Real: ',
    actualCompletionDateFull: 'Data de Conclusão Real',
    AutoAssign_Issue: 'Auto atribuir novas questões para:',
    AutoAssign_Note: 'O membro escolhido será atribuído toda vez que uma atividade for adicionada ao projeto',
    AutoAssign_Request: 'Auto atribuir novas solicitações para:',
    AutoAssign_Task: 'Auto atribuir novas tarefas para:',
    AutoAssign_Title: 'Auto atribuir',
    BaselineCapturedFeedback: 'A linha de base do projeto foi capturada. Vá para uma visualização de Gantt e escolha a opção \'Mostrar\' para verificar.',
    BaselineCaptureLabel: 'Capturar linha de base',
    BaselineOverwrite: 'Substituir a linha de base atual?',
    BaselineOverwriteDescription: 'Você já possui uma linha de base para este projeto. Se proceder, a linha de base atual será perdida.',
    BaselineOverwrittenFeedback: 'A linha de base do projeto foi sobrescrita. Vá para uma visualização de Gantt e escolha a opção \'Mostrar\' para verificar.',
    BaselineRecaptureLabel: 'Sobrescrever linha de base',
    BaselineSuccess: 'A linha de base foi capturada com sucesso.',
    Billed: 'Faturado',
    Billing: 'Faturamento',
    BillingSettingsTitle: 'Configurações de faturamento',
    BillingTypeNotBillable: 'Não faturável',
    BillingTypeProjectBillingSettings: 'Configurações de faturamento do projeto',
    btnNotifications: 'Notificações',
    BudgetLeft: 'restante',
    BudgetTotal: 'total',
    By: 'por ',
    Change: 'mudar',
    Close: 'Fechar',
    ConfirmStatusDialogTitle: 'Concluir \"{0}\"?',
    DayPluralFormat: '1#{0} dia#{0} dias',
    Days: '({0}d)',
    DeleteActivity: 'Excluir atividade',
    DeleteProject: 'Excluir projeto',
    Dependencies_Count: '1#{0} Dependência#{0} Dependências',
    DifferPermissionsMessage: 'indica que as permissões do membro atual do projeto diferem das permissões padrão do papel',
    Disable_Dates_Rollup: 'Desativar consolidação de datas',
    Disable_Dates_Rollup_Feedback: 'A consolidação de datas foi desativada',
    DueIn_Ok: 'devido em {0}',
    DueIn_Trouble: '{0} atrasado',
    DueIn_Warning: 'devido hoje',
    EditRoleAndPermissions: 'Editar papel e permissões',
    Enable_And_Reschedule: 'Habilitar e Reagendar',
    Enable_Dates_Rollup: 'Habilitar consolidação de datas',
    Enable_Dates_Rollup_Description: 'Habilitar a consolidação de datas irá reagendar este projeto.',
    Enable_Dates_Rollup_Feedback: 'A consolidação de datas foi habilitada',
    Enable_Dates_Rollup_Title: 'As datas do projeto serão atualizadas',
    endDate: 'Data de Término Planejada: ',
    endDateFull: 'Data de Término Planejada',
    endLessThenStartMsg: 'A \'Data de Término\' não pode ser menor que a \'Data de Início\'',
    estimatedHours: '1# hora estimada# horas estimadas',
    ExportToMsProject: 'Exportar para MS Project',
    Fields: '1#{0} campo#{0} campos',
    FillCustomFields: '{0} ainda deve ser preenchido',
    Follow: 'Seguir',
    hide_checklist_label: 'Esconder checklist',
    HideCustomFields: 'Esconder campos customizados',
    hoursLeft: '1# hora restante# horas restantes',
    HoursOf: 'horas de ',
    HtmlField_ReadAll: '... ler tudo',
    ImDoneText: 'Concluído',
    IsMilestone: 'Isto é um marco',
    issue: 'Questão',
    MarkAsMilestone: 'Marcar como um marco',
    MemberPermission_Add: 'Adicionar',
    MemberPermission_Add_For_Someone_Else: 'Adicionar para outra pessoa',
    MemberPermission_Add_Own: 'Adicionar próprio',
    MemberPermission_CanEditActualExpenses: 'Editar despesas reais',
    MemberPermission_CanEditPlannedExpenses: 'Editar despesas planejadas',
    MemberPermission_CanLogExpenses: 'Registrar despesas',
    MemberPermission_CanManageProjectMembers: 'Gerenciar membros e permissões',
    MemberPermission_CanManageProjectMembersAndAllocations: 'Gerenciar membros, permissões e alocações',
    MemberPermission_CanViewMembersAndAssignees: 'Visualizar',
    MemberPermission_Delete: 'Excluir',
    MemberPermission_Delete_All: 'Excluir todas',
    MemberPermission_Delete_Or_Archive: 'Excluir/Arquivar',
    MemberPermission_Edit: 'Editar',
    MemberPermission_Edit_All: 'Editar todas',
    MemberPermission_Edit_Assigned: 'Editar atribuído',
    MemberPermission_Manage_Assigned: 'Gerenciar atribuições',
    MemberPermission_View_All: 'Visualizar todas',
    MemberPermission_View_and_Manage: 'Visualizar e gerenciar',
    MemberPermission_View_Assigned: 'Visualizar atribuído',
    MemberPermissions_ExpensesTitle: 'Despesas:',
    MemberPermissions_MembersAndAssigneesTitle: 'Membros e atribuições:',
    MemberPermissions_TasksTitle: 'Atividades:',
    MemberPermissions_ThisProjectTitle: 'Projeto:',
    MemberPermissions_TimeEntriesTitle: 'Lançamentos de tempo:',
    Members: '1#{0} Membro#{0} Membros',
    no_assignee: 'Sem atribuição',
    On: 'em ',
    OwnBudget: 'Orçamento para esta atividade:',
    PercentDone: '1#% concluído#% concluído',
    PermissionsSettingsTitle: 'Permissões de {0}',
    project: 'Projeto',
    Project_NotFound_Message: 'O projeto solicitado não pôde ser encontrado, ou você não tem permissão para acessá-lo. Consulte seu administrador do {brandName} para possíveis causas. A chave do objeto é {0}.',
    Project_NotFound_Title: 'Projeto Solicitado Não Encontrado',
    Project_WasCompleted_Ok: 'O projeto foi concluído <b>{0} antes</b> de sua data de término planejada',
    Project_WasCompleted_Trouble: 'O projeto foi concluído  <b>{0} depois</b> de sua data de término planejada',
    Project_WasCompleted_Warning: 'O projeto foi concluído na sua data de término planejada',
    RatioOfMoneySpent: '1#{0} de {1} gasto#{0} de {1} gasto',
    RepeatActivity: 'Repetir',
    request: 'Solicitação',
    ResumeWorkHelpText: 'Você completou sua atribuição. ',
    ResumeWorkText: 'Retomar trabalho',
    RoleTitle: 'Papel para este projeto',
    Save: 'Salvar',
    Set_actualCompletionDate: 'Definir Data de Conclusão Real',
    Set_budget: 'Definir Orçamento',
    Set_categoryId: 'Definir Categoria',
    Set_customerId: 'Definir Cliente',
    Set_dates: 'Definir Datas ou Duração',
    Set_description: 'Adicionar descrição',
    Set_endDate: 'Definir Data de Término Planejada',
    Set_estimatedHours: 'Definir Horas Estimadas',
    Set_hoursLeft: 'Definir Horas Restantes',
    Set_labor_budget: 'Definir Orçamento de Mão de Obra',
    Set_portfolioId: 'Definir Portfólio',
    Set_short_hoursLeft: 'Definir Horas Restantes',
    SetAsRootLevel: 'Definir como atividade de nével superior',
    SetCompleted: 'Definir como Concluédo',
    short_hoursLeft: '1# hora restante# horas restantes',
    show_checklist_label: 'Mostrar lista de verificação',
    ShowCustomFields: 'Mostrar campos personalizados',
    Spent: '1#h gasto#h gastos',
    Status: 'Status: ',
    task: 'Tarefa',
    Task_NotFound_Message: 'A atividade solicitada não pôde ser encontrada, ou você não tem permissão para acessá-la. Consulte o seu administrador {brandName} para posséveis causas. Chave do objeto é {0}.',
    Task_NotFound_Title: 'Atividade Solicitada Não Encontrada',
    Task_WasCompleted_Ok: 'A atividade foi concluéda <b>{0} antes</b> de sua data de término planejada',
    Task_WasCompleted_Trouble: 'A atividade foi concluéda <b>{0} depois</b> de sua data de término planejada',
    Task_WasCompleted_Warning: 'A atividade foi concluéda na sua data de término planejada',
    today: 'Hoje',
    UnFollow: 'Deixar de seguir',
    WindowUnload_UnsavedChanges: 'Há alterações não salvas. Tem certeza de que deseja deixar esta página?',
};
